import { isMobileOnly } from '@/shared/libs/platform/device-type';
import { MOBILE_VIEWPORT_QUERY } from '@/shared/hooks/useIsMobile';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

export const TOP_CONTAINER_WIDTH = 1132;

export const TOP_EVENTS_INSET = brandIsPh ? 12 : 18;

export const TOP_EVENTS_INSET_QUERY = `(max-width: ${TOP_CONTAINER_WIDTH - 1}px), ${MOBILE_VIEWPORT_QUERY}`;

const SPORT_ICON_SRC = '/images/betting/sport_icon/{{sportName}}.svg';
export const SDK_SCRIPT_ID = 'topevents-sdk';
export const SDK_SCRIPT_SRC =
  'https://static.dev.phoenixapps.org/sdk/phoenix-sdk.umd.js';
export const EVENT_CARD_TEMPLATE_ID = 'custom-event-card';
export const OUTCOME_TEMPLATE_ID = 'custom-outcome';

export const EVENT_CARD_HTML = isMobileOnly
  ? `
      <a class="my-event-card swiper-slide is-mobile" data-event-id="{{eventId}}" href="{{eventUrl}}">
        <div class="event-header">
          <div class="tournament-container">
            <img src="${SPORT_ICON_SRC}" alt="sport icon"/>
            <span class="tournament">{{regionName}} - {{tournamentName}}</span>
          </div>
        </div>
        <div class="participants is-mobile">
          <span>{{participant1}}\nVS\n{{participant2}}</span>
        </div>
        <div class="time">{{startTime}}</div>
        <div class="outcomes is-mobile">{{outcomes}}</div>
      </a>
    `
  : `
      <a class="my-event-card swiper-slide is-desktop" data-event-id="{{eventId}}" href="{{eventUrl}}">
        <div class="event-header">
          <div class="tournament-container">
            <img src="${SPORT_ICON_SRC}" alt="sport icon"/>
            <div class="tournament">{{regionName}} - {{tournamentName}}</div>
          </div>
          <div class="date-time-container">
            <span class="time">{{startTime}}</span>
          </div>
        </div>
        <div class="participants is-desktop">
          <span>{{participant1}}\nVS\n{{participant2}}</span>
        </div>
        <div class="outcomes is-desktop">{{outcomes}}</div>
      </a>
    `;

export const OUTCOME_HTML = `
    <div class="my-outcome" data-odds="{{odds}}">
      <span>{{odds}}</span>
    </div>
  `;
